import { Config } from '../types';
import keys from './keys';
import contracts from './contracts';
import pools from './pools';
import tokenlists from './tokenlists';
import tokens from './tokens';
import rateProviders from './rateProviders';

const config: Config = {
  key: '421614',
  chainId: 421614,
  layerZeroChainId: 10231,
  chainName: 'Arbitrum Sepolia',
  name: 'Arbitrum Testnet Sepolia',
  shortName: 'Arb Sepolia',
  monorepoName: 'arbitrum-sepolia',
  slug: 'arbitrum-sepolia',
  network: 'arbitrum-sepolia',
  trustWalletNetwork: 'arbitrum',
  unknown: false,
  visibleInUI: true,
  testNetwork: true,
  rpc: `https://arb-sepolia.g.alchemy.com/v2/${keys.alchemy}`,
  ws: ``,
  publicRpc: 'https://sepolia-rollup.arbitrum.io/rpc',
  explorer: 'https://sepolia.arbiscan.io',
  explorerName: 'Arbiscan',
  // TODO(arbitrum-sepolia): point at the testnet subgraph(s) once deployed.
  subgraph: '',
  poolsUrlV2: '',
  subgraphs: {
    main: [''],
    aave: '',
    gauge: '',
    blocks: '',
  },
  bridgeUrl: 'https://bridge.arbitrum.io/',
  supportsEIP1559: false,
  supportsElementPools: false,
  blockTime: 2,
  nativeAsset: {
    name: 'Ether',
    address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    symbol: 'ETH',
    decimals: 18,
    deeplinkId: 'ether',
    logoURI: 'tokens/eth.png',
    minTransactionBuffer: '0.005',
  },
  thirdParty: {
    coingecko: {
      nativeAssetId: 'ethereum',
      platformId: 'arbitrum-one',
    },
  },
  addresses: {
    ...contracts,
  },
  pools,
  tokens,
  keys,
  gauges: {
    type: 3,
    weight: 0,
  },
  tokenlists,
  rateProviders,
};

export default config;
